import React from 'react';
import PropTypes from 'prop-types';

import { RecommendationSection, RecommendationContainer, RecommendationHeading, RecommendationDescription } from './styles';

const OurRecommendation = ({ recommendation, hotelType }) => (
  <RecommendationSection>
    <RecommendationContainer hotelType={hotelType}>
      <RecommendationHeading>Our Recommendation</RecommendationHeading>
      <RecommendationDescription dangerouslySetInnerHTML={{ __html : recommendation }} />
    </RecommendationContainer>
  </RecommendationSection>
);

OurRecommendation.propTypes = {
  recommendation: PropTypes.string,
  hotelType: PropTypes.number
};

export default OurRecommendation;
